import React from "react"
import { FormProvider } from "react-hook-form"

import { useProjectHistoryFilterFormViewModel } from "./model/useProjectHistoryFilterFormViewModel"
import "./styles/_project-history-filter.scss"
import { ProjectHistoryTimeFrameInput } from "./ui/ProjectHistoryTimeFrameInput"

export interface ProjectHistoryFilterState {
  timeFrame?: number | null
  searchTerm?: string | null
}

export interface ProjectHistoryFilterProps {
  onChange: (state: ProjectHistoryFilterState) => void
}

export const ProjectHistoryFilter = React.memo(
  ({ onChange }: ProjectHistoryFilterProps) => {
    const { form, timeFrameOptions } = useProjectHistoryFilterFormViewModel({
      onChange
    })

    return (
      <FormProvider {...form}>
        <form id="project-history-filter" className="project-history-filter">
          <ProjectHistoryTimeFrameInput options={timeFrameOptions} />
          {/* <ProjectHistorySearchInput /> */}
        </form>
      </FormProvider>
    )
  }
)
